<template>
  <div class="overlay" data-testid="font-overlay">
    <basic-overlay-style
      :bounding-box="boundingBox"
      :color="color"
      :border="false"
    />
    <div v-if="tooltipText">
      <button
        :id="getBoundingBoxId(boundingBox)"
        class="transparent-overlay-button"
        :style="getStyle(boundingBox)"
      ></button>
      <b-tooltip :target="getBoundingBoxId(boundingBox)">{{
        tooltipText
      }}</b-tooltip>
    </div>
  </div>
</template>

<script>
import BasicOverlayStyles from './BasicOverlayStyles';

export default {
  components: {
    'basic-overlay-style': BasicOverlayStyles,
  },
  props: {
    boundingBox: {
      type: Object,
      required: true,
    },
    color: {
      type: [Array, String],
      required: true,
    },
    tooltipText: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    getBoundingBoxId(boundingBox) {
      return `${boundingBox.top}, ${boundingBox.left}`;
    },
    getStyle(localBoundingBox) {
      return {
        position: `absolute`,
        height: `${localBoundingBox.height}px`,
        width: `${localBoundingBox.width}px`,
        borderRadius: 0,
        outline: 'none',
        border: 'none',
      };
    },
  },
};
</script>

<style scoped lang="scss">
.transparent-overlay-button {
  background-color: transparent;
  z-index: 1000;
}
</style>
